import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { initAnalytics } from "@/lib/analytics";

const CONSENT_KEY = "cookie_consent";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    initAnalytics();
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 w-80 animate-in slide-in-from-bottom-4 duration-300">
      <div className="rounded-xl border p-5" style={{ background: "#FAF1F0", borderColor: "#E8D5D3", boxShadow: "0 4px 24px 0 rgba(15,15,15,0.08), 0 1.5px 6px 0 rgba(15,15,15,0.04)" }}>
        <p className="mb-1 text-sm font-semibold text-foreground">Cookie Preferences</p>
        <p className="mb-4 text-sm text-muted-foreground leading-relaxed">
          We use cookies to analyze website traffic and improve your experience
          Learn more in our{" "}
          <Link to="/privacy" className="underline underline-offset-2 hover:text-primary">
            Privacy Policy.
          </Link>{" "}

        </p>
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            className="flex-1"
            onClick={handleDecline}
          >
            Decline
          </Button>
          <Button
            size="sm"
            className="flex-1"
            onClick={handleAccept}
          >
            Accept All
          </Button>
        </div>
      </div>
    </div>
  );
}
